import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete'
import {SortableElement} from 'react-sortable-hoc'
import styles from '../style/DraggableColorBoxStyles'


const DraggableColorBox = ({color,name,deleteColor}) => {
    const classes = makeStyles(styles({color,name}))();
    return (
        <div className={classes.root} style={{backgroundColor: color}}>
            <div className={classes.boxContent}>
                <span>{name}</span>
                <DeleteIcon className={classes.deleteIcon} onClick={deleteColor}/>
            </div>
        </div>
    )
}

export default SortableElement(DraggableColorBox)
